import React from 'react';
import './Products.css'; 
// import product1 from './products/Products (1).png';
import product2 from './products/Products (2).jpeg';
import product3 from './products/Products (3).jpg';
import product4 from './products/Products (4).jpg';
import product5 from './products/Products (5).jpg';
import product6 from './products/Products (6).jpg';
import product7 from './products/Products (7).jpg';
import product8 from './products/Products (8).jpg';
import product9 from './products/Products (9).png';
import product10 from './products/Products (10).png';
import product11 from './products/Products (11).png';
import product12 from './products/Products (12).png';
// import product13 from './products/Products (13).jpeg';
import product14 from './products/Products (14).jfif';
import product15 from './products/Products (15).png';
import product16 from './products/Products (16).png';
import product17 from './products/Products (17).png';
import { Link } from 'react-router-dom';

function Tab2Content() {
  return (
    <div className="container">
            <div className="product-container">
            <Link to="/products/ATMA SPHERE">
            <img src={product14} alt="Product 14" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div>
            <div className="product-container">
            <Link to="/products/CONSOLIDATED AUDIO BERLIN">
            <img src={product7} alt="Product 7" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
                </div>
            <div className="product-container">
            <Link to="/products/CSPORT">
            <img src={product8} alt="Product 8" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div>
            {/* <div className="product-container">
            <Link to="/products/Dynamic Sounds Associates">
            <img src={product1} alt="Product 1" className="image" />
            </Link>
            </div> */}
            <div className="product-container">
            <Link to="/products/HARTVIG AUDIO">
            <img src={product9} alt="Product 9" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div>
            <div className="product-container">
            <Link to="/products/KARAN ACOUSTICS">
            <img src={product10} alt="Product 10" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div>
            <div className="product-container">
            <Link to="/products/KEITH MONKS">
            <img src={product4} alt="Product 4" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div>
            <div className="product-container">
            <Link to="/products/KUDOS AUDIO">
            <img src={product3} alt="Product 3" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div>
            <div className="product-container">
            <Link to="/products/KUZMA">
            <img src={product2} alt="Product 2" className="image"/>
                {/* <div className="overlay">Product 2</div> */}
            </Link>
            </div>
            <div className="product-container">
            <Link to="/products/MICHELL AUDIO">
            <img src={product11} alt="Product 11" className="image"/>
                {/* <div className="overlay"></div>  */}
            </Link>
            </div>
            {/* <div className="product-container">
            <Link to="/products/RUSSELL K.">
            <img src={product13} alt="Product 13" className="image"/>
            </Link>
            </div> */}
            <div className="product-container">
            <Link to="/products/SOTA">
            <img src={product5} alt="Product 5" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div>
            <div className="product-container">
            <Link to="/products/TRENNER & FRIEDL">
            <img src={product16} alt="Product 16" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div>
            <div className="product-container">
            <Link to="/products/TRI-PLANAR">
            <img src={product6} alt="Product 6" className="image"/>
                {/* <div className="overlay">Product 6</div> */}
            </Link>
            </div>
            <div className="product-container">
            <Link to="/products/UBERLIGHT">
            <img src={product17} alt="Product 17" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div>
            <div className="product-container">
            <Link to="/products/WALKER AUDIO">
            <img src={product12} alt="Product 12" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div> 
            <div className="product-container">
            <Link to="/products/ZESTO AUDIO">
            <img src={product15} alt="Product 15" className="image"/>
                {/* <div className="overlay"></div> */}
            </Link>
            </div>
            </div>
  );
}

export default Tab2Content;
